// src/components/operationCenter/widgets/token/risk/TwTailMetricsWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import TailMetricsPanel from "@/components/tokenPage/risk/TailMetricsPanel";

const TwTailMetricsWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <TailMetricsPanel />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwTailMetricsWidget;
